import { render, staticRenderFns } from "./DeliveryModal.vue?vue&type=template&id=388a265a&scoped=true"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryModal.vue?vue&type=style&index=0&id=388a265a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a265a",
  null
  
)

export default component.exports